import regex from '../modules/regex-rules.js';
import { customValidate, customMessages, restrictInput } from '../modules/custom-validation.js';
import { setLoadingState, getAlertHtml, toggleFields, resetForm } from '../modules/form-helpers.js';
import { slideUp, slideDown } from '../modules/animations.js';
import { errorPlacement, highlight, unhighlight } from '../modules/form-validation.js';

new toggleFields(document.getElementById('form-efresh-business-new'));

const $ = window.jQuery;
const recaptcha = window.grecaptcha;

if (!$ || !$.fn || !$.fn.validate) {
	throw new Error('jQuery sau jQuery Validate nu sunt disponibile.');
}

if (!recaptcha || !recaptcha.ready) {
	throw new Error('reCAPTCHA nu e disponibil.');
}

window.dataLayer = window.dataLayer || [];

class Form {
	constructor({ formContainer, formName, formType, formCategory }) {
		if (!formContainer) {
			throw new Error('`formContainer` e null.');
		}

		if (!formContainer.dataset.fetchUrl) {
			throw new Error(`#${formContainer.id}: data-fetch-url e null.`);
		}

		if (!formName) {
			throw new Error('`formName` e null.');
		}

		if (!formType) {
			throw new Error('`formType` e null.');
		}

		if (!formCategory) {
			throw new Error('`formCategory` e null.');
		}

		this.form = formContainer;
		this.responseContainer = formContainer.querySelector('#response-message');

		if (!this.responseContainer) {
			throw new Error('#response-message e null.');
		}

		this.fetchError = false;
		this.errorType = '';
		this.autoCloseTimer = 10000;

		// dataLayer related
		this.formDescriptor = {
			form_name: formName,
			form_type: formType,
			form_category: formCategory,
			form_url: window.location.href.split('?')[0],
		};

		this.init();
		this.validate();
		this.updateRules();
	}

	init() {
		// Metode custom de validare
		$.validator.addMethod('alpha', customValidate.alpha);
		$.validator.addMethod('alphaNumeric', customValidate.alphaNumeric);
		$.validator.addMethod('phone', customValidate.phone);
		$.validator.addMethod('companyCode', customValidate.companyCode);
		$.validator.addMethod('companyName', customValidate.companyName);
		$.validator.addMethod('codClient', customValidate.codClient);

		// Restrictionari inputuri
		restrictInput('#nume-firma', regex.companyName);
		restrictInput('#cui', regex.companyCodeChars);
		restrictInput('#telefon', regex.digits);
		restrictInput('#cod-client', regex.digits);
		restrictInput('#reprezentant', regex.lettersSpacesHyphens);
		restrictInput('#localitate', regex.lettersSpacesHyphensDigits);

		// Reguli de validare
		this.rules = {
			nume_firma: {
				required: true,
				companyName: true,
				minlength: 3,
				maxlength: 100,
			},
			cui: {
				required: true,
				companyCode: true,
				minlength: 3,
				maxlength: 15,
			},
			domeniu: {
				required: true,
			},
			reprezentant: {
				required: true,
				alpha: true,
				minlength: 3,
				maxlength: 40,
			},
			judet: {
				required: true,
			},
			localitate: {
				required: true,
				alphaNumeric: true,
				minlength: 3,
				maxlength: 100,
			},
			telefon: {
				required: true,
				phone: true,
			},
			email: {
				required: true,
				email: true,
			},
			client_engie: {
				required: true,
			},
			putere_aer_conditionat: {
				required: true,
			},
			aer_conditionat: {
				required: true,
			},
			acord_gdpr: {
				required: true,
			},
			acord_express: {
				required: true,
			},
		};

		// Mesaje eroare la validare
		this.messages = {
			nume_firma: {
				required: customMessages.required('Nume firmă'),
				companyName: customMessages.companyName('Nume firmă'),
				minlength: customMessages.minlength('Nume firmă'),
				maxlength: customMessages.maxlength('Nume firmă', 100),
			},
			cui: {
				required: customMessages.required('CUI'),
				companyCode: customMessages.companyCode('CUI'),
				minlength: customMessages.minlength('CUI'),
				maxlength: customMessages.maxlength('CUI', 15),
			},
			domeniu: {
				required: customMessages.required('Domeniu de activitate'),
			},
			reprezentant: {
				required: customMessages.required('Reprezentant legal'),
				alpha: customMessages.alpha('Reprezentant legal'),
				minlength: customMessages.minlength('Reprezentant legal'),
				maxlength: customMessages.maxlength('Reprezentant legal', 40),
			},
			judet: {
				required: customMessages.required('Județ'),
			},
			localitate: {
				required: customMessages.required('Localitate'),
				alphaNumeric: customMessages.alphaNumeric('Localitate'),
				minlength: customMessages.minlength('Localitate'),
				maxlength: customMessages.maxlength('Localitate', 100),
			},
			telefon: {
				required: customMessages.required('Telefon'),
				minlength: customMessages.minlength('Telefon', 10, 'cifre'),
				maxlength: customMessages.maxlength('Telefon', 10, 'cifre'),
				phone: customMessages.phone('Telefon'),
			},
			email: {
				required: customMessages.required('Email'),
				email: customMessages.email('Email'),
			},
			client_engie: {
				required: customMessages.radio('Client ENGIE'),
			},
			cod_client: {
				required: customMessages.required('Cod client'),
				codClient: customMessages.codClient('Cod client'),
			},
			putere_aer_conditionat: {
				required: customMessages.required('Putere aer condiționat'),
			},
			aer_conditionat: {
				required: customMessages.required('Model aer condiționat'),
			},
			acord_gdpr: {
				required: customMessages.gdpr(),
			},
			acord_express: {
				required: customMessages.required('Acordul pentru începerea executării contractului și pierderea dreptului de retragere'),
			},
		};

		document.addEventListener('change', this.updateRules.bind(this));

		// Reset la form
		this.form.addEventListener('reset', () => {
			const submitBtn = document.getElementById('submit');
			if (submitBtn) {
				submitBtn.disabled = false;
			}
		});

		// Modele aer conditionat dinamice, preluate din data-models (JSON)
		this.initAcModels();
	}

	/**
	 * Actualizare reguli dinamice cod client + starea submit la non-clienti
	 */
	updateRules() {
		const $codClient = $('[name="cod_client"]');
		const submitBtn = document.getElementById('submit');
		const radioClient = document.querySelector('[name="client_engie"]:checked')?.value;

		const isClient = radioClient === 'da-client';

		// Toggle submit button state
		if (submitBtn) {
			submitBtn.disabled = radioClient === 'nu-client';
		}

		if ($codClient.length) {
			$codClient.rules('remove', 'required');
			if (isClient) {
				$codClient.rules('add', {
					required: true,
					codClient: true,
				});
			} else {
				$codClient.val('');
			}
		}
	}

	/**
	 * Modele aer conditionat dinamice, preluate din data-models (JSON)
	 */
	initAcModels() {
		try {
			const powerModelsMap = JSON.parse(this.form.dataset.models || '{}');
			const powerSelect = this.form.querySelector('#putere-aer-conditionat');
			const modelSelect = this.form.querySelector('#aer-conditionat');
			const modelWrapper = this.form.querySelector('#modele-aer-conditionat');

			powerSelect?.addEventListener('change', (e) => {
				const defaultOption = '<option value="" selected disabled>Alege modelul dorit</option>';
				const levelModels = powerModelsMap[e.target.value] || [];

				const optionsHtml = defaultOption + levelModels.map((model) => `<option value="${model.name}">${model.name}</option>`).join('');

				if (modelSelect) {
					modelSelect.innerHTML = optionsHtml;
					modelSelect.disabled = false;
				}

				if (modelWrapper) {
					if (e.target.value !== '') {
						modelWrapper.classList.remove('nj-form-item--disabled');
					} else {
						modelWrapper.classList.add('nj-form-item--disabled');
					}
				}
			});
		} catch (err) {
			console.error(err.message);
		}
	}

	async handleSubmit(form, event) {
		event?.preventDefault();

		const formData = new FormData(form);
		formData.append('action', 'write_efresh_business_new_lead');

		const recaptchaPassed = recaptcha.getResponse();

		// GTM
		const formDetails = `Judet: ${formData.get('judet') || ''} | Domeniu activitate: ${formData.get('domeniu') || ''} | Client Engie: ${formData.get('client_engie') || ''} | Model aer conditionat: ${formData.get('aer_conditionat') || ''}`;

		if (recaptchaPassed) {
			setLoadingState('loading');

			try {
				const response = await fetch(form.dataset.fetchUrl, {
					method: 'POST',
					body: formData,
				});

				const { success, data } = await response.json();

				this.errorType = !success ? 'fetch' : '';

				if (success) {
					this.responseContainer.innerHTML = getAlertHtml('success', data.responseTitle || 'Datele au fost trimise cu succes', data.response, 'mt-4 auto-close');
					this.responseContainer.style.setProperty('--autoclose', `${this.autoCloseTimer}ms`);
					setTimeout(() => {
						slideUp(this.responseContainer);
						this.responseContainer.style.removeProperty('--autoclose');
						this.responseContainer.querySelector('#response-message-inner').classList.remove('auto-close');
					}, this.autoCloseTimer);

					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_submitted',
						form_details: formDetails,
						lead: 'Succes',
						phone_number: `+4${formData.get('telefon')}`,
						email: formData.get('email'),
					});

					resetForm(this.form);
				} else {
					this.responseContainer.innerHTML = getAlertHtml('danger', data.responseTitle || 'Am întâmpinat o eroare', data.response);

					window.dataLayer.push({
						...this.formDescriptor,
						event: 'form_error',
						error_field: data.field || data.reason || 'Server',
						error_message: data.response,
					});
				}
			} catch (err) {
				console.error('Fetch error:', err.message);
				this.errorType = 'fetch';
				this.responseContainer.innerHTML = getAlertHtml('danger');
			} finally {
				setLoadingState();
				grecaptcha.reset();
				slideDown(this.responseContainer);
			}
		} else {
			this.errorType = 'recaptcha';
			this.responseContainer.innerHTML = getAlertHtml('danger', 'Bifează că nu ești robot.', 'Pentru a solicita oferta, e necesar să bifezi reCAPTCHA.');

			window.dataLayer.push({
				...this.formDescriptor,
				event: 'form_error',
				form_details: formDetails,
				lead: 'Captcha invalid',
				error_field: 'reCaptcha',
				error_message: 'reCaptcha nebifat',
			});

			slideDown(this.responseContainer);
		}
	}

	handleValidation(event, validator) {
		validator.errorList.forEach((error) => {
			let field = '';
			if (error.element.name === 'acord_gdpr') {
				field = 'Acord GDPR';
			} else if (error.element.name === 'acord_express') {
				field = 'Acord express';
			} else if (error.element.type === 'radio') {
				field = error.element.closest('.nj-radio-group')?.querySelector('.nj-radio-group__legend')?.textContent.trim() || error.element.name;
			} else {
				field = error.element.closest('.nj-form-item')?.querySelector('.nj-form-item__label')?.textContent.trim() || error.element.name;
			}

			window.dataLayer.push({
				...this.formDescriptor,
				event: 'form_error',
				error_field: field,
				error_message: error.message,
			});
		});
	}

	handleErrors(validator) {
		if (validator.numberOfInvalids() > 0) {
			this.errorType = 'validation';
			this.responseContainer.innerHTML = getAlertHtml('danger', 'Câmpurile marcate cu roșu conțin erori', 'Te rugăm să verifici și să reîncerci.');
			slideDown(this.responseContainer);
		} else {
			if (this.errorType === 'validation') {
				this.errorType = '';
				slideUp(this.responseContainer);
			}
		}
		validator.defaultShowErrors();
	}

	validate() {
		const self = this;

		$(this.form).validate({
			focusInvalid: false,
			submitHandler: async function (form, event) {
				await self.handleSubmit(form, event);
			},
			invalidHandler: function (event, validator) {
				self.handleValidation(event, validator);
			},
			showErrors: function () {
				self.handleErrors(this);
			},
			rules: this.rules,
			messages: this.messages,
			errorPlacement,
			highlight,
			unhighlight,
			errorClass: 'text-danger line-height-1-3 t-centi e-form-error',
		});
	}
}

recaptcha.ready(() => {
	const formContainer = document.getElementById('form-efresh-business-new');
	if (formContainer) {
		new Form({
			formContainer: formContainer,
			formName: 'Business - aparate aer conditionat',
			formType: 'lead',
			formCategory: 'Business',
		});
	}
});
